<template>
  <div class="outerWrap">
    <slot name="top" />
    <div
      class="underWrap"
      @touchmove="$emit('touchmove', $event)"
      @touchend="$emit('touchend', $event)"
      @mouseenter="$emit('mouseenter', $event)"
      @mouseleave="$emit('mouseleave', $event)"
      @click="$emit('click', $event)"
    >
      <slot />
      <slot name="over-default" />
    </div>
    <slot name="nudge" />
    <slot name="bot" />
  </div>
</template>

<script setup lang="ts">
defineEmits(['touchmove', 'touchend', 'mouseenter', 'mouseleave', 'click'])
</script>

<style scoped>
.outerWrap {
  width: 100%;
  box-shadow: var(--shadow-regular);
  border-radius: 2px;
  position: relative;
}

.plainWrapper {
  z-index: 1;
}

.noZs .plainWrapper,
.noZs .underWrap :deep(> div:first-child),
.noZs .underWrap {
  z-index: unset;
}

.vOverflowing .underWrap :deep(> div:first-child) {
  overflow: visible;
}

.underWrap :deep(> div:first-child) {
  padding: 20px;
  border-radius: 2px;
  overflow: hidden;
  background-color: var(--color-white);
  z-index: 1;
}

.underWrap {
  position: relative;
  z-index: 0;
}

div.noUnderWrapPadding .underWrap,
div.noUnderWrapPadding .underWrap :deep(> div) {
  padding: 0px;
}

div.outerWrap.noShadow,
div.outerWrap.noShadow:hover {
  box-shadow: none;
}

div.outerWrap.alwaysShadow,
div.outerWrap.alwaysShadow:hover {
  box-shadow: var(--shadow-regular);
}

div.outerWrap.hasMargin {
  margin-bottom: 48px;
}
@media screen and (min-width: 768px) {
  .outerWrap:hover {
    box-shadow: var(--shadow-regular-dark);
  }
}
</style>
